module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Shared link for Customer")]), _c('h6', {
    staticClass: "card-subtitle"
  }, [_vm._v("This link can access in 15 day.")]), _c('label', [_vm._v("Web Link")]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.linkToWeb
    }
  }), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.linkToWeb),
      expression: "linkToWeb",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function (e) { return _vm.onCopy(e, 'web'); }),
      expression: "(e) => onCopy(e, 'web')",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.isCopyingWeb
    }
  }, [_vm._v(_vm._s(_vm.btnCopyTxtWeb))])]), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.linkToWeb,
      "target": "_blank"
    }
  }, [_vm._v("Open Web Link")])])]), _c('hr'), _c('label', [_vm._v("PDF Link")]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.pdfLink
    }
  }), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.pdfLink),
      expression: "pdfLink",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function (e) { return _vm.onCopy(e, 'pdf'); }),
      expression: "(e) => onCopy(e, 'pdf')",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.isCopyingPdf
    }
  }, [_vm._v(_vm._s(_vm.btnCopyTxtPdf))])]), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.pdfLink,
      "target": "_blank"
    }
  }, [_vm._v("Open PDF Link")])])]), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('onClose')
      }
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d46dedc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/sharedLinkForCustomer.vue
// module id = 407
// module chunks = 3